import { ChatState } from "./definitions";

/*
 * "Modo humano" = a conversa foi transbordada e um atendente humano assumiu.
 * Nesse estado o widget NUNCA mostra o balão de "bot digitando" nem trava o input.
 *
 * Sinal primário: conversation.attributes.handoff === true (carimbado pelo synccx-api no
 *   transbordo) → vira chat.humanMode via o conversationListener.
 * Reforço (fallback): entrou um participante que não é o cliente (o atendente do Flex vira
 *   participant ao aceitar). Assume que o bot NÃO é participant da conversa (só o cliente é,
 *   até o atendente entrar) — se isso mudar, este fallback precisa de ajuste.
 */
export const isHumanMode = (chat: ChatState): boolean => {
    if (chat.humanMode) {
        return true;
    }
    const currentUserId = chat.conversationsClient?.user?.identity;
    return Boolean(chat.participants?.some((p) => p.identity && p.identity !== currentUserId));
};
